import { h } from 'preact';
import { registerPatternDecoder } from './index';
import { IToastOptions } from '@/components/create-toast';
import { defaultErrorImg } from '@/assets/error';

registerPatternDecoder(/^\{slot-error\}/, (match, options: IToastOptions) => {
  const errorImg = defaultErrorImg;
  return <img src={errorImg} alt="🪙" style={{ height: '1em', verticalAlign: 'middle' }} />;
});
